<div class="content-box">
  <div class="title-cancel">
    <h3>Equipe</h3>
    <i class="button-icon fas fa-xmark fa-lg cursor-pointer" (click)="closeSideBar()"></i>
  </div>
  <div class="form-infos">
    <div>
      {{
      sidebarIdSelected != '-'
      ? 'Atualizado: ' + (currentTeamVehicle?.location?.createdAt | date: 'dd/MM/yyyy - HH:mm')
      : ''
      }}
    </div>

    <!-- Dados Gerais -->
    <h3 class="info-title">Dados Gerais</h3>

    <div class="white-box">
      <div class="d-flex flex-column w-100">
        <div class="row-gap">
          <div class="col-6 p-0">
            <img [src]="
              currentTeam?.leaderMember?.user?.imageURL
                ? currentTeam?.leaderMember?.user?.imageURL
                : 'assets/icons/camera.svg'
            " class="modal-img" />
            <span>{{
              currentTeam?.leaderMember?.user?.firstName + ' ' + currentTeam?.leaderMember?.user?.lastName
              }}</span>
          </div>
          <div class="col-6 p-0">
            <i class="far fa-clipboard-list-check"></i>
            <span> Tarefas do Dia: </span>
            <span class="text-muted">{{ totalTasksToday }} </span>
          </div>
        </div>
        <div class="row-gap mt-2">
          <div class="col-12 p-0 flex-wrap">
            <h4>Membros:</h4>
            <div class="member-initials" [tooltip]="member.name" *ngFor="let member of currentTeam.members">
              {{getInitials(member)}}
            </div>
            <div *ngIf="!currentTeam.members.length">-</div>
          </div>
        </div>
      </div>
    </div>
    <!-- Dados Gerais -->

    <!-- Tarefas Atrasadas | | Concluídas/do Dia -->
    <ng-container *ngFor="let item of teamTasks | keyvalue: originalOrder; index as i">
      <h3 class="info-title">{{ item.key }}</h3>

      <ng-container *ngFor="let task of item.value">
        <div class="white-box px-0 py-0">
          <accordion [isAnimated]="true" [closeOthers]="true" class="w-100">
            <accordion-group [isOpen]="task?.isAccOpen">
              <div class="accordion-div" accordion-heading (click)="openAccordionGroup(task, item.value)">
                <div class="accordion-head">
                  <i class="far fa-alarm-exclamation red-dark" *ngIf="i == 2" (mouseover)="setTaskMouseEnter(task)"
                    triggers="mouseenter:mouseleave" [popover]="popoverLate"></i>
                  <i class="fas fa-circle" (mouseover)="setTaskMouseEnter(task)" triggers="mouseenter:mouseleave"
                    [popover]="popoverStatus" [class]="task.status"></i>
                  <i class="far" [class]="setTaskIcon(task.taskType)" (mouseover)="setTaskMouseEnter(task)"
                    triggers="mouseenter:mouseleave" [popover]="popoverType"></i>
                  <i class="fas fa-flag" (mouseover)="setTaskMouseEnter(task)" triggers="mouseenter:mouseleave"
                    [popover]="popoverPriority" [class]="task.priority"></i>
                  <span *ngIf="!task?.isAccOpen">{{ task?.taskType | enumText: 'TaskType' }}</span>
                  <span>{{ task?.name }}</span>

                  <!-- Collapse -->
                  <div class="collapse-button">
                    <i class="fa-regular fa-lg" [ngClass]="task?.isAccOpen ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                  <!-- Collapse -->
                </div>
                <div *ngIf="task?.loading" style="height: 70px">
                  <app-loading-page></app-loading-page>
                </div>

                <div class="collapse-body" *ngIf="task?.isAccOpen">
                  <!-- Informações Gerais -->
                  <h4 class="text-muted">Informações Gerais</h4>
                  <span class="text-muted">Status: <span class="text-dark">{{ task?.status | enumText: 'TaskStatus'
                      }}</span></span>
                  <span class="text-muted">Tipo da Tarefa: <span class="text-dark">{{ task?.taskType | enumText:
                      'TaskType' }}</span></span>
                  <span class="text-muted">Prioridade:
                    <span class="text-dark">{{
                      task?.priority ? (task?.priority | enumText: 'OrderPriority') : 'Não informado'
                      }}</span></span>
                  <!-- Informações Gerais -->

                  <!-- Data e Hora -->
                  <div class="row-gap">
                    <!-- Início -->
                    <div class="box-date-time" (h)="setTaskMouseEnter(task)" triggers="mouseenter:mouseleave"
                      [popover]="popoverExecution">
                      <i class="far fa-calendar-clock"></i>
                      <span> {{ task?.executionDate | date: 'dd/MM/yy' }}</span>
                    </div>
                    <!-- Início -->

                    <!-- Fim -->
                    <div class="box-date-time" (mouseover)="setTaskMouseEnter(task)" triggers="mouseenter:mouseleave"
                      [popover]="popoverEnd">
                      <i class="fas fa-calendar-clock"></i>
                      <span> {{ task?.endDate | date: 'dd/MM/yy' }}</span>
                    </div>
                    <!-- Fim -->

                    <!-- Hora -->
                    <div class="box-date-time" (mouseover)="setTaskMouseEnter(task)" triggers="mouseenter:mouseleave"
                      [popover]="popoverTime">
                      <i class="far fa-timer"></i>
                      <span> {{ task?.resolutionTime ?? 0 }}h</span>
                    </div>
                    <!-- Hora -->
                  </div>
                  <!-- Data e Hora -->

                  <!-- Veículo -->
                  <div class="row-gap">
                    <img [src]="task?.vehicle?.vehicleImage.url" class="modal-img" />
                    <span>{{ task?.vehicle?.licensePlate }}</span>
                  </div>
                  <!-- Veículo -->

                  <div class="px-0">
                    <hr />
                  </div>

                  <!-- Localização -->
                  <h4 class="text-muted">Localização</h4>
                  <span>
                    {{
                    (task?.address?.road ? task?.address?.road + ', ' : '') +
                    (task?.address?.road ? task?.address?.house_number ?
                    task?.address?.house_number + ' - ' : 's/ nº - ' : '') +
                    (task?.address?.suburb ? task?.address?.suburb + ', ' : '') +
                    (task?.address?.city ? task?.address?.city : '') +
                    (task?.address?.postcode ? (', ' + task?.address?.postcode) : '')
                    }}
                  </span>

                  <!-- Localização -->

                  <div class="px-0">
                    <hr />
                  </div>

                  <!-- Descrição -->
                  <h4 class="text-muted">Descrição</h4>
                  <span>
                    {{ task?.description || 'A tarefa não possui descrição' }}
                  </span>

                  <!-- Descrição -->

                  <div class="px-0">
                    <hr />
                  </div>

                  <!-- Atividades -->
                  <ng-container>
                    <h3 class="info-title">Atividades da Tarefa</h3>
                    <div>
                      <div class="row d-flex justify-content-between align-items-center text-muted w-100 mx-0 px-1">
                        <div class="col-auto px-0" style="font-size: 12px">Atividades</div>
                        <div class="col-auto px-0" style="font-size: 12px">
                          Progresso {{ task?.progress?.completedActivities + '/' + task?.progress?.activities }}
                        </div>
                      </div>
                      <div class="d-flex w-100" style="padding-right: -4px; padding-left: -4px">
                        <div class="progress-task-bar" *ngFor="let activity of task['taskActivitiesProgress']"
                          [ngStyle]="{ background: activity ? 'var(--green-base)' : 'var(--snow-dark)' }"></div>
                      </div>
                      <div class="activity-sign-box" *ngFor="let activity of task['activitySigns']">
                        <div class="row mx-0 d-flex align-items-center">
                          <img [src]="activity?.signName | enumSvg: 'Signaling'" alt="sign-svg" height="38px"
                            width="38px" style="object-fit: contain;" />
                          <p class="m-0 sign-text mx-3">{{ activity?.signName | enumText: 'Signaling' }}</p>
                        </div>
                        <p class="m-0">{{ activity?.progress }}</p>
                      </div>
                    </div>
                  </ng-container>
                  <!-- Atividades -->

                  <button class="btn-popup button-details">
                    <div class="button-div-details" (click)="goToTaskDetail(task?.id)">
                      <p class="m-0">VER TAREFA</p>
                      <i class="far fa-angle-right"></i>
                    </div>
                  </button>
                </div>
              </div>
            </accordion-group>
          </accordion>
        </div>
      </ng-container>
    </ng-container>
    <!-- Tarefas Atrasadas | | Concluídas/do Dia -->
  </div>
  <button class="btn-popup button-details">
    <div class="button-div-details" (click)="goToTeamDetail(currentTeam.id)">
      <p class="m-0">VER EQUIPE</p>
      <i class="far fa-angle-right"></i>
    </div>
  </button>
</div>

<!-- Template Popover Tipo de Tarefa  -->
<ng-template #popoverType>
  <span class="text-white popover-info">{{
    'Tarefa de ' + (popoverCurrentTask?.taskType | enumText: 'TaskType')
    }}</span>
</ng-template>
<!-- Template Popover Tipo de Tarefa  -->

<!-- Template Popover Prioridade da Tarefa  -->
<ng-template #popoverPriority>
  <span class="text-white popover-info">{{
    'Prioridade ' + popoverCurrentTask?.priority
    ? (popoverCurrentTask?.priority | enumText: 'OrderPriority')
    : 'Não informado'
    }}</span>
</ng-template>
<!-- Template Popover Prioridade da Tarefa  -->

<!-- Template Popover Status da Tarefa  -->
<ng-template #popoverStatus>
  <span class="text-white popover-info">{{ popoverCurrentTask?.status | enumText: 'TaskStatus' }}</span>
</ng-template>
<!-- Template Popover Status da Tarefa  -->

<!-- Template Popover Data Execução  -->
<ng-template #popoverExecution>
  <span class="text-white popover-info">Data de Execução</span>
</ng-template>
<!-- Template Popover Data Execução  -->

<!-- Template Popover Data de Conclusão  -->
<ng-template #popoverEnd>
  <span class="text-white popover-info">Data de Conclusão</span>
</ng-template>
<!-- Template Popover Data de Conclusão  -->

<!-- Template Popover Tempo de Resolução  -->
<ng-template #popoverTime>
  <span class="text-white popover-info">Tempo de Resolução</span>
</ng-template>
<!-- Template Popover Tempo de Resolução  -->

<!-- Template Popover Atrasada para concluir  -->
<ng-template #popoverLate>
  <span class="text-white popover-info">Atrasada para Concluir</span>
</ng-template>
<!-- Template Popover Atrasada para concluir  -->
